<template>
  <v-container>
    <h2>Nos réalisations avant / après</h2>

    <v-carousel
        cycle
        :height="$vuetify.breakpoint.smAndDown ? '800' : '600'"
        hide-delimiter-background
        show-arrows-on-hover
        interval="2000000"
      >
        <v-carousel-item
          v-for="(slide, i) in slides"
          :key="i"
        >
          <!-- <v-sheet
            :color="colors[i]"
            height="100%"
          > -->
            <UsersOne :slide="slide" />
          <!-- </v-sheet> -->
        </v-carousel-item>
      </v-carousel>

  </v-container>
</template>


<script>
import UsersOne from './UsersOne'
import {mapGetters, mapActions} from 'vuex'

export default {
  components: { UsersOne },
  computed: {
    ...mapGetters('strapi', ['slides']),
  },
  methods: {
    ...mapActions('strapi', ['getSlide']),
  },
  async mounted () {
    this.getSlide()
  }
}
</script>
<style scoped>
h2 {
  text-align: center;
  font-size: 2em;
  padding-bottom: 1em;
}
</style>